import { render, staticRenderFns } from "./BrandEditor.vue?vue&type=template&id=382aa837&scoped=true"
import script from "./BrandEditor.vue?vue&type=script&lang=js"
export * from "./BrandEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382aa837",
  null
  
)

export default component.exports